const { camelCase } = require("change-case");

// https://www.w3.org/Style/Examples/007/fonts.en.html

const filterJoin = (arr) => arr.filter(Boolean).join(", ");

const generate = {
  // 'cursive': fonts that emulate handwriting.
  cursive: (fontFamily) =>
    filterJoin([fontFamily, "cursive", "ui-rounded", "system-ui"]),
  // 'fantasy': decorative fonts, for titles, etc.
  fantasy: (fontFamily) =>
    filterJoin([fontFamily, "fantasy", "ui-rounded", "system-ui"]),
  // 'monospace': fixed-width fonts.
  monospace: (fontFamily) =>
    filterJoin([fontFamily, "monospace", "ui-monospace", "system-ui"]),
  // 'sans-serif': normal fonts without serifs.
  sansSerif: (fontFamily) =>
    filterJoin([fontFamily, "sans-serif", "ui-sans-serif", "system-ui"]),
  // 'serif': normal fonts with serifs.
  serif: (fontFamily) =>
    filterJoin([fontFamily, "serif", "ui-serif", "system-ui"]),
};

const fontConfigs = [
  {
    label: "American Typewriter",
    name: "american typewriter",
    type: "serif",
  },
  {
    label: "Apple Chancery",
    name: "apple chancery",
    type: "cursive",
  },
  {
    label: "Arial",
    name: "arial",
    type: "sansSerif",
  },
  {
    label: "Arial Black",
    name: "arial black",
    type: "sansSerif",
  },
  {
    label: "Arial Narrow",
    name: "arial narrow",
    type: "sansSerif",
  },
  {
    label: "Bradley hand",
    name: "bradley hand",
    type: "cursive",
  },
  {
    label: "Brush Script MT",
    name: "brush script mt",
    type: "cursive",
  },
  {
    label: "Chalkduster",
    name: "chalkduster",
    type: "cursive",
  },
  {
    label: "Comic Sans MS",
    name: "comic sans ms",
    type: "cursive",
  },
  {
    label: "Courier",
    name: "courier",
    type: "monospace",
  },
  {
    label: "Courier New",
    name: "courier new",
    type: "monospace",
  },
  {
    label: "Cursive",
    type: "cursive",
  },
  {
    label: "Didot",
    name: "didot",
    type: "serif",
  },
  {
    label: "Fantasy",
    type: "fantasy",
  },
  {
    label: "Georgia",
    name: "georgia",
    type: "serif",
    isDefault: true,
  },
  {
    label: "Helvetica",
    name: "helvetica",
    type: "sansSerif",
  },
  {
    label: "Herculanum",
    name: "herculanum",
    type: "fantasy",
  },
  {
    label: "Impact",
    name: "impact",
    type: "sansSerif",
  },
  {
    label: "Luminari",
    name: "luminari",
    type: "fantasy",
  },
  {
    label: "Marker Felt",
    name: "marker felt",
    type: "sansSerif",
  },
  {
    label: "Menlo",
    name: "menlo",
    type: "monospace",
  },
  {
    label: "Monaco",
    name: "monaco",
    type: "monospace",
  },
  {
    label: "Monospace",
    type: "monospace",
  },
  {
    label: "Optima",
    name: "optima",
    type: "serif",
  },
  {
    label: "Palatino",
    name: "palatino",
    type: "serif",
  },
  {
    label: "Sans-Serif",
    type: "sansSerif",
  },
  {
    label: "Serif",
    type: "serif",
  },
  {
    label: "Snell Roundhand",
    name: "snell roundhand",
    type: "cursive",
  },
  {
    label: "Tahoma",
    name: "tahoma",
    type: "sansSerif",
  },
  {
    label: "Times New Roman",
    name: "times new roman",
    type: "serif",
  },
  {
    label: "Times",
    name: "times",
    type: "serif",
  },
  {
    label: "Trattatello",
    name: "trattatello",
    type: "fantasy",
  },
  {
    label: "Trebuchet MS",
    name: "trebuchet ms",
    type: "serif",
  },
  {
    label: "Verdana",
    name: "verdana",
    type: "sansSerif",
  },
]
  .map((fontConfig) => {
    fontConfig.key = camelCase(fontConfig.label);
    fontConfig.fontFamily = generate[fontConfig.type](fontConfig.name);
    return fontConfig;
  })
  .sort((a, b) => a.label.localeCompare(b.label));

function utilGetFamily(id) {
  for (let fontConfig of fontConfigs)
    if (fontConfig.key === id || fontConfig.label === id)
      return fontConfig.fontFamily;
}

const font = { configs: fontConfigs, family: utilGetFamily };

module.exports = font;
